export const CREATE_DEALTYPE_INFO_REQUEST = "CREATE_DEALTYPE_INFO_REQUEST";
export const CREATE_DEALTYPE_INFO_SUCCESS = "CREATE_DEALTYPE_INFO_SUCCESS";
export const CREATE_DEALTYPE_INFO_ERROR = "CREATE_DEALTYPE_INFO_ERROR";
export const ClEAR_MESSAGE = "ClEAR_MESSAGE";
